import React from 'react';
import type PlanDependenciesReportType from '@atlassian/jira-spa-apps-advanced-roadmaps-plan/src/ui/plan-dependencies-report/index-old.tsx';
import { markAsProductBundleReady } from '@atlassian/jira-spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

/**
 * Plan DependenciesReport page
 */
// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
export const LazyPlanDependenciesReport = lazyForPaint<typeof PlanDependenciesReportType>(
	() =>
		markAsProductBundleReady(
			import(
				/* webpackChunkName: "async-plan-dependencies-report", jiraSpaEntry: "async-plan-dependencies-report" */ '@atlassian/jira-spa-apps-advanced-roadmaps-plan/src/ui/plan-dependencies-report/index-old.tsx'
			),
		),
	{ ssr: false },
);

const AsyncPlanDependenciesReport = (): React.JSX.Element => (
	<LazyPage Page={LazyPlanDependenciesReport} pageId="plan-dependencies-report" shouldShowSpinner />
);

export default AsyncPlanDependenciesReport;
